import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { Subject } from "rxjs";
import { SwabSample } from "./models/swabSample";
import { Injectable } from "@angular/core";
import { LabMDM } from "../masterdata/models/lab";
import { timeout, tap } from 'rxjs/operators';

//Service used for crud opertaions on the swab sample data
@Injectable()
export class SwabSampleService {

  constructor(private http: HttpClient) {
  }

  /**
   * @description Save by Swab Sample.
   * @param swabSample 
  */
  addSwabSample(swabSample: SwabSample): Observable<BBResponseContainer> {
    let url = environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL + 'swabSample'
    return this.http.post<BBResponseContainer>(url, swabSample).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

   /**
   * @description Get the List of Swab Samples.
   * @param lab
   * @param swabBarcode 
  */
 getSwabSample(lab: LabMDM, swabBarcode: string): Observable<BBResponseContainer> {
  let url = environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL + 'swabSample/' + swabBarcode;
  let requestParam = new HttpParams().set('labId', lab._id);
  const options = url ? { params: requestParam } : {};
  return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
    error.url = url;
  }));
}

  /**
   * @description Get the List of Swab Samples.
   * @param lab
   * @param pageIndex
   * @param barcode 
  */
  getSwabSamples(lab: LabMDM, pageIndex: number): Observable<BBResponseContainer> {
    let url = environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL + 'swabSample';
    let requestParam = new HttpParams().set('labId', lab._id)
      .set('startPage', pageIndex.toString());
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  /**
   * @description Gets Swab Samples based on filter parameters. Can also be empty
   * @param lab 
   * @param barcode 
   * @param clientId 
   * @param plateId 
   * @param orderItemId 
   */
  getSwabSamplesByFilter(lab: LabMDM, barcode: string, clientId: string, plateId: string, orderItemId: string): Observable<BBResponseContainer> {
    let url = environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL + 'swabSamples';
    let requestParam = new HttpParams().set('labId', lab._id)
      .set('barcode', barcode)
      .set('clientId', clientId)
      .set('plateId', plateId)
      .set('orderItemId', orderItemId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  /**
   * @description Gets paginated Swab Samples based on filter parameters. Can also be empty
   * @param lab 
   * @param barcode 
   * @param clientId 
   * @param plateId 
   * @param orderItemId 
   * @param pageIndex 
   */
  getSwabSamplesByFilterPaginated(lab: LabMDM, barcode: string, clientId: string, plateId: string, orderItemId: string, pageIndex: number): Observable<BBResponseContainer> {
    let url = environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL + 'swabSamples/' + pageIndex;
    let requestParam = new HttpParams().set('labId', lab._id)
      .set('barcode', barcode)
      .set('clientId', clientId)
      .set('plateId', plateId)
      .set('orderItemId', orderItemId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  /**
     * @description Update by Swab Sample.
     * @param swabSample 
    */
  updateSwabSample(swabSample: SwabSample): Observable<BBResponseContainer> {    
    let url = environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL + 'swabSample'
    return this.http.put<BBResponseContainer>(url, swabSample).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  /**
   * @description Get the List of Swab Samples.
   * @param lab
   * @param plateId 
  */
 getSwabSamplesByPlateId(lab: LabMDM, plateId: string): Observable<BBResponseContainer> {
  let url = environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL + 'plate/' + plateId;
  let requestParam = new HttpParams().set('labId', lab._id);
  const options = url ? { params: requestParam } : {};
  return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
    error.url = url;
  }));
}

  //shared Methods
  // Observable string sources
  private emitChangeSource = new Subject<any>();
  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();
  // Service message commands
  emitChange(change: any) {
        console.log("emit change "+change);
        this.emitChangeSource.next(change);
  }

}